import React from 'react'
import {track} from '@web/lib/analytics'
const HotClick = ({children, href, data = null, className = ''}) => {
  return <section className={className} onClick={e => track(e, data, href)}>
    {children}
  </section>
}

export default HotClick;
